import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Experiences from './pages/Experiences';
import ExperienceDetail from './pages/ExperienceDetail';
import ExperienceAdd from './pages/ExperienceAdd';
import Advertisements from './pages/Advertisements';
import AdvertisementDetail from './pages/AdvertisementDetail';
import AdvertisementAdd from './pages/AdvertisementAdd';
import Transport from './pages/Transport';
import TransportAdd from './pages/TransportAdd';
import Profile from './pages/Profile';

// Admin
import Dashboard from './admin/Dashboard';
import AdminProducts from './admin/Products';
import ProductAdd from './admin/ProductAdd';
import ProductEdit from './admin/ProductEdit';
import AdminArticles from './admin/Articles';
import ArticleAdd from './admin/ArticleAdd';
import ArticleEdit from './admin/ArticleEdit';
import AdminAdvertisements from './admin/Advertisements';
import AdminExperiences from './admin/Experiences';
import AdminTransports from './admin/Transports';

const App: React.FC = () => {
  return (
    <Layout>
      <Routes>
        {/* ── صفحات عمومی ────────────────────────────── */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/article/:id" element={<ArticleDetail />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/experience/:id" element={<ExperienceDetail />} />
        <Route path="/advertisements" element={<Advertisements />} />
        <Route path="/advertisement/:id" element={<AdvertisementDetail />} />
        <Route path="/transport" element={<Transport />} />

        {/* ── صفحات محافظت‌شده (نیاز به لاگین) ────────── */}
        <Route element={<ProtectedRoute />}>
          <Route path="/profile" element={<Profile />} />
          <Route path="/experience/add" element={<ExperienceAdd />} />
          <Route path="/advertisement/add" element={<AdvertisementAdd />} />
          <Route path="/transport/add" element={<TransportAdd />} />
        </Route>

        {/* ── صفحات مدیریت (نیاز به ادمین) ────────────── */}
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          
          {/* مدیریت محصولات */}
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/products/add" element={<ProductAdd />} />
          <Route path="/admin/products/edit/:id" element={<ProductEdit />} />
          
          {/* مدیریت مقالات */}
          <Route path="/admin/articles" element={<AdminArticles />} />
          <Route path="/admin/article/add" element={<ArticleAdd />} />
          <Route path="/admin/article/edit/:id" element={<ArticleEdit />} />
          
          {/* مدیریت آگهی‌ها */}
          <Route path="/admin/advertisements" element={<AdminAdvertisements />} />

          
          {/* مدیریت تجارب */}
          <Route path="/admin/experiences" element={<AdminExperiences />} />
          
          {/* مدیریت بار و ماشین */}
          <Route path="/admin/transports" element={<AdminTransports />} />
        </Route>
      </Routes>
    </Layout>
  );
};

export default App;